import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_burger",
  "use": "svg_burger-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"svg_burger\"><path fill=\"currentColor\" d=\"M0 0h8v2H0zM0 6h8v2H0zM0 3h8v2H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol